module.exports = __webpack_public_path__ + "img/4c015da7403efe2a23f5f04a88610721.7027df13.jpg";